import { render } from "./TopbarElement.vue?vue&type=template&id=2a67fa11&scoped=true"
import script from "./TopbarElement.vue?vue&type=script&lang=js"
export * from "./TopbarElement.vue?vue&type=script&lang=js"

import "./TopbarElement.vue?vue&type=style&index=0&id=2a67fa11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a67fa11"]])

export default __exports__